/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import * as RadioGroup from "@radix-ui/react-radio-group";

import type { ThemeType } from "../../../../../global/emotion";
import { numericPixels, radius, spacing } from "../../../../../global/emotion";
import { Text } from "../../../_base/_core/Text/Text.emotion";

const cardStyle: Interpolation<ThemeType> = (theme) => ({
  backgroundColor: "inherit",
  border: `${numericPixels[2]} ${theme.semanticColors.neutralsLowest} solid`,
  ":is([data-state='checked'])": {
    backgroundColor: "inherit",
    border: `${numericPixels[2]} ${theme.semanticColors.primary} solid`,
  },
  borderRadius: radius.ms,
  cursor: "pointer",
  display: "inline-flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  padding: spacing.m,
  textAlign: "left",
  width: spacing.full,
});

export type OptionCardProps<T extends string = string> = {
  label: string;
  sublabel?: string;
  value: T;
};

export const OptionCard = <T extends string = string>({
  label,
  sublabel,
  value,
}: OptionCardProps<T>) => (
  <RadioGroup.Item css={cardStyle} value={value}>
    <Text type="title" size="s">
      {label}
    </Text>
    {sublabel && (
      <Text type="detail" size="xl">
        {sublabel}
      </Text>
    )}
  </RadioGroup.Item>
);
